import React, {useContext} from 'react';
import styled from "styled-components";
import {PropertiesDispatcherContext} from "@providers/properties";
import CardFull, {ImageCard, DetailsCard, Price} from "../card.full";
import {Address} from "../components/card.info";
import {useWindowSize} from "@helpers/windows.size";
import {array_chunk} from "@helpers/arrays";
import RadiusGenerate from "@helpers/radius.generate";
import CardFullSkeleton from "../card_full_skeleton";
import SwiperPropertiesCard from "../swiper_properties_card";

function LandingProperties({city_id, properties, className}) {
    const windowSize = useWindowSize();
    const properties_dispatcher = useContext(PropertiesDispatcherContext);

    const handleShowProperty = (e, link, media = 0) => {
        e.preventDefault();
        e.stopPropagation();

        properties_dispatcher({
            type: 'PUSH_STATE',
            payload: {
                link: link,
                href: '/properties/show',
                media: (media > 5) ? 5 : media,
                loading: true,
                offsetTop: window.pageYOffset + 1,
                back: false
            }
        })
    };

    const chunk_properties = array_chunk(properties, 4);

    if (windowSize > 991) {
        return (
            <Container className="container">
                {
                    (chunk_properties.length) ?

                        chunk_properties.map((chunk, key) =>
                            <div className={"row " + (key > 0 ? 'mt-32' : '')} key={key}>
                                {
                                    (chunk.length) ?
                                        chunk.map((property, key) =>
                                            <Col3 key={property.id}>
                                                <CardFull property={property} handleShowProperty={handleShowProperty} selectedCityId={city_id}/>
                                            </Col3>
                                        )
                                        : ''
                                }
                            </div>
                        )
                        :
                        array_chunk([...Array(8)], 4).map((chunk, key) =>
                            <div className={"row " + (key > 0 ? 'mt-32' : '')} key={key}>
                                {
                                    (chunk.length) ?
                                        chunk.map((property, key) =>
                                            <Col3 key={key}>
                                                <CardFullSkeleton/>
                                            </Col3>
                                        )
                                        : ''
                                }
                            </div>
                        )
                }
            </Container>
        )
    } else {
        return (
            <Container>
                <SwiperPropertiesCard
                    freeMode={false}
                    cartClassName=""
                    properties={properties}
                    handleShowProperty={handleShowProperty}
                />
            </Container>
        )
    }
}

export default React.memo(LandingProperties);

// styles
const Col3 = styled.div`
    flex: 0 0 25%;
    max-width: 25%;
    padding-left: 16px;

    &:last-child {
        padding-left: 0;
    }
`;

const Container = styled.div`
    ${ImageCard} {
        //height: 180px;
         
        img {
            ${RadiusGenerate('8px')};
        } 
    }

    ${DetailsCard} {
        margin-top: 0;  
    }

    ${Price} {
        margin-top: 0;  
    }
    
    ${Address} {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;